import { Controller } from "@hotwired/stimulus"

// Debounces form submission on input
//
// Usage:
//   <form data-controller="debounce">
//     <input data-action="input->debounce#submit" />
//   </form>
//
// With custom delay (default 1000ms):
//   <form data-controller="debounce" data-debounce-delay-value="300">
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 1000 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    this.clearTimeout()
  }

  submit() {
    this.clearTimeout()
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
